import React from "react";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import 'leaflet/dist/leaflet.css'
import {Icon} from 'leaflet'
import { MAP_DEFAULT } from "library/helpers/constUtils";

 
export const StreetMap = ({location}) => {
  const position = [location.lat, location.lng];

  const iconMap = new Icon({
    iconUrl: MAP_DEFAULT.markerImage, 
    iconSize: [25, 45],
  });

 
  return (
    <MapContainer 
      center={position} 
      zoom={location.zoom} 
      scrollWheelZoom={false} 
      style={{with: "100%", height: "400px"}}
      attributionControl={false}
    >
      <TileLayer
    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {location.isLocationGpsProvided && 
        <Marker 
          position={position}
          icon={iconMap}
          >
          <Popup>
            {location.title}
          </Popup>
      </Marker>}
    </MapContainer>
  )
};